import React from 'react';

class FilterGradient extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_type: props.filter_type,
      filter_gradient_from: props.filter_gradient_from,
      filter_gradient_to: props.filter_gradient_to,
    };
  }

  shouldComponentUpdate(nextProps) {
    const bg = document.querySelector('#hu-filter .hu-filter-gradient');
    if (nextProps.filter_type !== 'gradient')
      bg.className = bg.className.replace(/\sselected/g, '');
    else 
      bg.className = 'hu-filter-gradient' + ' selected';
    return false;
  }

  render() {
    const { filter_type } = this.props;
    const selected = filter_type === 'gradient';
    
    return (
      <div className={ selected ? 'hu-filter-gradient selected' : 'hu-filter-gradient' }></div>
    );
  }
}

export default FilterGradient;


// WEBPACK FOOTER //
// ./app/js/components/filter/FilterGradient.js